import { render } from "./IncluirObservacao.vue?vue&type=template&id=f43c6fe2&scoped=true"
import script from "./IncluirObservacao.vue?vue&type=script&lang=js"
export * from "./IncluirObservacao.vue?vue&type=script&lang=js"

import "./IncluirObservacao.vue?vue&type=style&index=0&id=f43c6fe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f43c6fe2"]])

export default __exports__